<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2023-05-05 15:11:33
 * @Description: 云渲染工具栏
 * @LastEditors: fengxiaojing
-->
<template>
  <div>
    <div :class="`tool_${direction}`" class="tool">
      <div class="item">
        <template v-if="mainScreenFileName">
          <el-tooltip effect="dark" :content="mainScreenFileName" placement="top">
            <div class="text-white ml-10px text-14px filename">{{ mainScreenFileName }}</div>
          </el-tooltip>
          <div class="ml-10px text-14px">
            <img src="@/assets/images/player_imgs/line.png" />
          </div>
        </template>
        <div :class="`tag_${direction} ${tabBarId}`">
          <el-tag
            v-for="(tag, tagIndex) in tags"
            :key="tag.val"
            @click="tagsClick(tag.val, tag, tagIndex)"
            disable-transitions
            :class="{ selected: selectTagList.includes(tag.val) }"
          >
            <template v-if="tag.children && tag.children.length > 0">
              <el-popover
                :placement="placement[direction]"
                popper-class="tag_popover"
                :width="`${tag.children.length * 32 + 20}`"
                trigger="hover"
              >
                <div class="tag_popover__item">
                  <el-tag
                    v-for="tagChild in tag.children"
                    :key="tagChild.val"
                    disable-transitions
                    @click="tagsClickChild(tagChild.val, tagChild, tag, tagIndex)"
                    :class="
                      activeTag === tagChild.val
                        ? 'actived'
                        : selectTagList.includes(tagChild.val)
                        ? 'selected'
                        : ''
                    "
                    class="m-r-5"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="tagChild.name"
                      :placement="placement[direction]"
                    >
                      <span class="iconfont text-20px text-white" :class="tagChild.iconName"></span>
                    </el-tooltip>
                  </el-tag>
                </div>
                <span
                  slot="reference"
                  class="iconfont text-20px text-white"
                  :class="tag.iconName"
                ></span>
              </el-popover>
            </template>
            <template v-else>
              <el-tooltip effect="dark" :content="tag.name" :placement="placement[direction]">
                <span
                  class="text-20px text-white"
                  :class="
                    [
                      'imgAnnotation',
                      'viewImgAnnotation',
                      'PreferenceSetting',
                      'saveCameraView',
                    ].includes(tag.val)
                      ? tag.iconName
                      : `${tag.iconName} iconfont`
                  "
                ></span>
              </el-tooltip>
            </template>
          </el-tag>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { resetObjectValue } from '@/assets/js/commonUtil.js'

export default {
  name: 'tabBar',
  props: [
    'direction',
    'tags',
    'activeTag',
    'selectTagList',
    'mainScreenFileName',
    'disable',
    'tabBarId',
  ],
  data() {
    return {
      placement: {
        bottom: 'top',
        bottom_1: 'top',
        top: 'bottom',
      },
      changeActiveTag: false, // 是否切换tag
      lastClickTag: '', // 上一次点击的tag
    }
  },
  watch: {
    activeTag() {
      if (!this.disable) {
        this.changeActiveTag = true
        const index = _.findIndex(this.tags, ['val', this.activeTag])
        this.addClass(index, 'tag')
      }
    },
    selectTagList: {
      deep: true,
      handler() {},
    },
  },
  created() {
    if (this.activeTag && !this.disable) {
      this.changeActiveTag = true
      const index = _.findIndex(this.tags, ['val', this.activeTag])
      this.addClass(index, 'tag')
    }
  },
  methods: {
    /**
     * @description: 悬浮框点击事件
     * @return {*}
     */
    tagsClickChild(val, tagChild, tag, index) {
      if (!this.disable) {
        if (tag.val !== 'more') {
          tag = resetObjectValue(tag, tagChild)
        }
        this.tagsClick(val, tagChild, index)
      }
    },
    tagsClick(val, tag) {
      if (!this.disable) {
        this.$emit('tagsClick', val, tag)
      }
    },
    /**
     * @description: 气泡动画
     * @param {*} index：目标元素索引
     * @param {*} info：只有父级tag有气泡动画，悬浮框无
     * @return {*}
     */
    addClass(index, info) {
      if (info === 'tag') {
        // 不存在激活的
        if (index === -1) {
          document.styleSheets[0].addRule(`.${this.tabBarId}::after`, 'content: none;')
        } else {
          // 判断当前是否有激活的Tag
          switch (this.direction) {
            case 'bottom':
            case 'bottom_1':
            case 'top':
              this.changeActiveTag &&
                document.styleSheets[0].addRule(
                  `.${this.tabBarId}::after`,
                  ` left: ${index * 43.5 + 6}px; transition: left 1s;content: ''`
                )
              break
            case 'left':
            case 'right':
              this.changeActiveTag &&
                document.styleSheets[0].addRule(
                  `.${this.tabBarId}::after`,
                  ` top: ${index * 43.5 + 6}px; transition: top 1s;content: '';`
                )

              break
            default:
              break
          }
          this.changeActiveTag = false
        }
      }
    },
  },
}
</script>
<style lang="scss">

.el-popover.tag_popover {
  padding: 0px;
  background-color: #d0efff;
  background: linear-gradient(#02457a, #1167b1);
  border: none;
  min-width: 20px;
  &[x-placement^='top'] .popper__arrow {
    border-top-color: #1167b1;
    &::after {
      border-top-color: #1167b1;
    }
  }
}

</style>
<style lang="scss" scoped>

.tool {
  cursor: pointer;
  z-index: 100;
  &_bottom,
  &_bottom_1 {
    bottom: 36px;
    margin-right: 10px;
    height: 40px;
    .item {
      display: flex;
      align-items: center;
      height: 44px;
      .el-tag {
        margin: 0 5px;
        padding: 5px;
        span {
          width: 23.5px;
          height: 23px;
          text-align: center;
          line-height: 23px;
        }
      }
    }
  }
  &_top {
    top: 36px;
    margin-right: 10px;
    height: 40px;
    .item {
      display: flex;
      align-items: center;
      height: 40px;
      .el-tag {
        margin: 0 5px;
        padding: 5px;
        span {
          width: 23.5px;
          height: 23px;
          text-align: center;
          line-height: 23px;
        }
      }
    }
  }
  .item {
    border-radius: 12px;
    background-color: #1167b1;
    background: linear-gradient(#02457a, #1167b1);
    box-shadow: 1px 1px 5px #1167b1;
    .filename {
      max-width: 160px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .tag_bottom,
    .tag_bottom_1 {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      z-index: 1;
      &::after {
        position: absolute;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: #d0efff;
        background: linear-gradient(#d0efff, #1167b1);
        z-index: -1;
      }
    }
  }
}
img {
  width: 23px;
  height: 23px;
}
.el-tag {
  padding: 5px;
  border: none;
  display: flex !important;
  align-items: center;
  background-color: #ffffff00;
  span {
    width: 23.5px;
    height: 23px;
    text-align: center;
    line-height: 23px;
    z-index: 10;
  }
  &.selected {
    animation: rock 1s;
    position: relative;
    &::after {
      position: absolute;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      border-color: #0d66af;
      background: linear-gradient(#003d73, #3a94e1);
      z-index: -1;
      left: 1px;
      content: '';
    }
  }
}
.tag_popover {
  &__item {
    display: flex;
    align-items: center;
    padding: 5px;
    height: 40px;
    border-radius: 12px;
    .el-tag {
      margin: 5px 0;
      padding: 5px;
      background-color: #ffffff00;
      border: none;
      display: flex !important;
      align-items: center;
      & span {
        width: 23.5px;
        height: 23px;
        text-align: center;
        line-height: 23px;
      }
      &.actived {
        border-radius: 50%;
        background-color: #d0efff;
        background: linear-gradient(#1167b1, #6db5da);
      }
    }
  }
}
@keyframes rock {
  0% {
    -webkit-transform: translateX(0px);
    transform: translateX(0px);
  }
  25% {
    -webkit-transform: translateX(-2px);
    transform: translateX(-2px);
  }
  50% {
    -webkit-transform: translateX(0px);
    transform: translateX(0px);
  }
  75% {
    -webkit-transform: translateX(2px);
    transform: translateX(2px);
  }
  100% {
    -webkit-transform: translateX(0px);
    transform: translateX(0px);
  }
}

</style>
